import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  findIndex,
  propEq,
} from 'ramda';
import Input from '../../common/Input';
import Wysisyg from '../../common/Wysisyg';
import '../../css/forms/default-forms.css';
import fields from './fields';
import Breadcrumbs from '../../common/Breadcrumbs';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import { linkDataToFields } from '../../utils/fields';
import { saveEmailTemplate, fetchEmailTemplateById, updateEmailTemplate } from '../../api/emailTemplate';
import '../../css/forms/default-forms.css';
import hasAccess from "../../helpers/permissionChecker";

export class EmailTemplatesEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      fieldsSync: false,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  componentWillMount() {
    this.fetchDataRouteById();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fieldsSync === false) {
      const currentEmailTemplate = path(['emailTemplate', 'emailTemplate'], this.props);

      if (currentEmailTemplate) {
        const fields = linkDataToFields(currentEmailTemplate, this.state.fields);

        this.setState({
          fields: fields,
          fieldsSync: true,
        });
      }
    }
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      this.props.saveForm(
        path(['emailTemplate', 'emailTemplate', 'id'], this.props),
        processFields(this.state.fields)
      );
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToEmailTemplates();
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'emailTemplate',
      'permTypeKey': 'edit',
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
           { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
           { url: '/pages/emailtemplates', icon: 'email', name: 'Email Templates' },
           { icon: 'edit', name: 'Edit Email Templates' },
          ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Edit Email Template
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
                }
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Input
                    disabled={disableFieldForEdit}
                    field={this.state.fields['name']}
                    onChange={this.changeFormValue}
                  />
                  <Wysisyg
                    disabled={disableFieldForEdit}
                    field={this.state.fields['content']}
                    onChange={this.changeFormValue}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveForm: (id, data) => {
      updateEmailTemplate(id, { details: JSON.stringify(data) })(dispatch);
    },
    goToEmailTemplates: () => {
      dispatch(push('/pages/emailtemplates'));
    },
    getDataById: (id) => {
      fetchEmailTemplateById(id)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplatesEdit);



// WEBPACK FOOTER //
// ./src/containers/EmailTemplatesEdit/index.js